var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBrk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 80,
    viewBox: "0 0 230 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.789 0.641113H155.145V78.8548H180.789V58.3397L185.918 53.211L198.74 78.8548H229.512L202.586 32.0548L226.948 0.641113H197.458L180.789 24.3617V0.641113Z",
    fill: "#3700FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.216 59.6219C101.678 55.7753 93.3863 41.8849 89.1123 35.2603C84.1973 42.526 74.5808 57.0575 73.726 62.1863C73.0849 66.0329 72.4438 79.4959 89.1123 79.4959C105.781 79.4959 104.499 62.8274 103.216 59.6219Z",
    fill: "#3700FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.167 0H75.0082L87.8301 19.874H114.756C115.825 19.6603 121.167 21.1562 121.167 26.926C121.167 32.5507 118.312 33.1454 116.181 33.5894C115.64 33.7021 115.145 33.8051 114.756 33.9781H96.1644L125.014 78.8548H150.658L132.707 49.3644C136.553 47.8685 147.722 41.1395 146.811 25.6438C145.634 5.63762 132.216 2.55356 123.409 0.529504C122.621 0.348301 121.869 0.175593 121.167 0ZM43.5945 0.641096H0V78.8548C12.3945 79.4959 39.1068 80.3934 46.8 78.8548C56.4164 76.9315 67.9562 71.2922 67.9562 57.0575C67.9562 44.2356 58.7671 39.5342 53.211 37.8247C57.6986 36.1151 66.1611 29.6186 64.1096 17.3096C62.0581 5.00055 49.5781 1.06849 43.5945 0.641096ZM24.7203 17.8641H33.0493C36.7293 17.8641 39.7125 20.8473 39.7125 24.5273C39.7125 28.2073 36.7293 31.1905 33.0493 31.1905H24.7203V17.8641ZM35.9018 47.4417H25.0031V61.5458H35.9018C39.7965 61.5458 42.9538 58.3885 42.9538 54.4938C42.9538 50.599 39.7965 47.4417 35.9018 47.4417Z",
    fill: "#3700FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrk);
export default __webpack_public_path__ + "static/media/logo_BRK.b83b6c90318945d4fb3805cf879ec8a1.svg";
export { ForwardRef as ReactComponent };